import React, { useEffect, useMemo, useRef, useState } from 'react';
import ArenaTrophiesCard from '../../../components/arena/arena-trophies-card';
import MissingUsernameBanner from './missing-username-banner';
import DonateSetupNudge from '../../../components/donate-setup-nudge/donate-setup-nudge';
import InfiniteScroll from 'react-infinite-scroll-component';
import { usePostUser } from '../../../hooks/post/usePostUser';
import _, { size } from 'lodash';
import Loading from '../../../components/loading/loading.component';
import CreatePost from '../../../components/create-post/create-post.component';
import EditProfiledDialog from '../../../components/edit-profile-dialog/edit-profile-dialog';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../configuration';
import { fetchProfile } from '../../../redux/features/auth/slice';
import { Post } from '../../../components';
import UkSlider from '../../../components/slider/uk-slider.component';
import { fetchLeaderboardUserApi } from '../../../api/user-profile/leaderboard';
import dayjs from 'dayjs';
import { useCategories } from '../../../hooks/use-categories/useCategories';
import _get from 'lodash/get';
import { useNavigate } from 'react-router-dom';
import Group from './Group';
import { FriendPage } from '../../friend';
import AccountSettings from './AccountSettings';
import { TabDonate } from './DonateTab';
import Dashboard from './Dashboard';
import { DonateGoalContent } from '../../donate-goal/donate-goal-content';
import { Advertisement } from './Advertisement';
import { TrapeziumButton } from '../../../components/buton-trapezium';
import { CustomDropdown } from '../../user-setting/tabs/custom-dropdown';
import { DialogTop } from '../../user-setting/tabs/dialog-top';
import CreatorCollabTab from '../../../components/brand-deal/brand-profile/creator-collab-tab';
import { useCreatorBrandProfile } from '../../../hooks/use-creator-brand-profile';
import { BRAND_COLLAB_TAB, BRAND_PROFILE_COPY, resolveProfileTab } from '../../../utils/brand-profile';
// import Slider from 'react-slick';

interface Props {
  profile: any;
  changeTab?: any;
  tabActive?: any;
  userId?: string;
}

const Timeline: React.FC<Props> = ({
  profile,
  changeTab,
  tabActive: tabActiveProp,
  userId,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [leaderboard, setLeaderboard] = useState<any>();
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [activeTabLeaderboard, setActiveTabLeaderboard] = useState('donator');
  const [pageNumber, setPageNumber] = useState<number>(1);
  const { getPostCategory } = useCategories({ type: 'post' });
  const [isOpenFullTop, setIsOpenFullTop] = useState<boolean>(false);
  const [month, setMonth] = useState<number>(new Date().getMonth() + 1);
  const [isCurrent, setIsCurrent] = useState<boolean>(true);
  const {
    data: listPost,
    hasMore,
    appendNewPost,
    removePost,
  } = usePostUser({ pageNumber, userId: profile.userId });
  const collab = useCreatorBrandProfile(profile?.userId);
  const tabActive = resolveProfileTab(tabActiveProp, !!collab?.visible);
  const handleUpdateProfileSuccess = async () => {
    await dispatch(fetchProfile());
  };
  const profileUser = useSelector(
    (state: RootState) => state.features.auth.profile
  );
  const { city, isShowMarry, sex } = profile;
  const handleClick = (tab: string) => {
    setActiveTabLeaderboard(tab);
    toggleDropdown();
  };

  const navigate = useNavigate();
  const toggleDropdown = () => setIsDropdownVisible(!isDropdownVisible);
  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const response = await fetchLeaderboardUserApi(profile?.userId);
        setLeaderboard(response);
      } catch (error) {
        console.error('Failed to fetch leaderboard:', error);
      }
    };
    fetchLeaderboard();
  }, [profile?.userId]);
  // const settings = {
  //   dots: false,
  //   infinite: false,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   centerMode: true,
  //   centerPadding: '40px',
  // };
  const renderContent = (tabActive: string) => {
    switch (tabActive) {
      case 'dashboard':
        return (
          <Dashboard profile={profile} listPost={listPost} leaderboard={leaderboard} />
        );

      case 'timeline':
        return (
          <div className="flex flex-col gap-[10px]">
            <CreatePost
              profileUser={!!profileUser}
              onCreatedSuccess={(newPost) => {
                appendNewPost(newPost);
              }}
            />
            {/* <div className="flex w-full flex-col border rounded-xl border-[#E5E7EB] dark:border-slate-700">
              <div className="flex justify-between items-center p-3">
                <h3 className="font-semibold text-[22px] leading-[26px] font-[#18191E] ">
                  Bài viết đã ghim
                </h3>
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="40" height="40" rx="20" fill="#EAEFFA" />
                  <path
                    d="M29.7503 18.06L24.2659 23.5444C24.6878 24.735 24.8659 26.7225 23.0284 29.1694C22.8982 29.3411 22.7332 29.4833 22.5441 29.5867C22.3551 29.6901 22.1463 29.7524 21.9315 29.7694H21.8284C21.4311 29.7677 21.0504 29.6094 20.769 29.3288L16.2503 24.81L13.0347 28.035C12.8913 28.1736 12.6997 28.2511 12.5003 28.2511C12.3009 28.2511 12.1093 28.1736 11.9659 28.035C11.8251 27.8928 11.7461 27.7008 11.7461 27.5006C11.7461 27.3005 11.8251 27.1085 11.9659 26.9663L15.1909 23.7506L10.6534 19.2131C10.5029 19.0648 10.3856 18.8862 10.3094 18.6891C10.2331 18.4921 10.1997 18.281 10.2112 18.07C10.2227 17.859 10.279 17.6529 10.3762 17.4653C10.4735 17.2777 10.6095 17.1129 10.7753 16.9819C13.1565 15.06 15.4347 15.4444 16.4378 15.7538L21.9409 10.2506C22.2233 9.97238 22.6038 9.81641 23.0003 9.81641C23.3967 9.81641 23.7773 9.97238 24.0597 10.2506L29.7503 15.9413C29.8903 16.0799 30.0015 16.2449 30.0773 16.4267C30.1532 16.6085 30.1923 16.8036 30.1923 17.0006C30.1923 17.1977 30.1532 17.3927 30.0773 17.5746C30.0015 17.7564 29.8903 17.9214 29.7503 18.06Z"
                    fill="#657384"
                  />
                </svg>
              </div>
              <div className="relative p-3 min-h-[500px] max-w-[900px]">
                <Slider {...settings}>
                  {listPost?.map((post) => (
                    <Post
                      customClassName="mx-[6px] post-slide"
                      removePost={removePost}
                      key={post.id}
                      post={post}
                      getPostCategory={getPostCategory}
                    />
                  ))}
                </Slider>
              </div>
            </div> */}
            {size(listPost) ? (
              <InfiniteScroll
                dataLength={listPost.length}
                next={() => setPageNumber((prev) => prev + 1)}
                hasMore={hasMore}
                loader={<Loading classname="mx-auto" />}
                endMessage={null}
                scrollableTarget="body"
              >
                <div className="flex-1 xl:space-y-6 space-y-3">
                  {listPost?.map((post) => (
                    <Post
                      removePost={removePost}
                      key={post.id}
                      post={post}
                      getPostCategory={getPostCategory}
                    />
                  ))}
                </div>
              </InfiniteScroll>
            ) : (
              <p className="text-sm text-slate-800 userDonates:text-slate-50 font-medium text-center mt-10">
                Bạn chưa có bài viết nào
              </p>
            )}
          </div>
        );

      case 'friend':
        return <FriendPage />;

      case 'settings':
        return <AccountSettings profile={profile} />;

      case 'group':
        return <Group />;

      case 'history-donate':
        return <TabDonate />;

      case 'quyen-gop':
        return <DonateGoalContent profile={profile} isOwner={!userId} />;

      case BRAND_COLLAB_TAB:
        return collab?.visible ? <CreatorCollabTab creatorId={profile.userId} profile={collab} isOwner={!userId} /> : null;

      default:
        return null;
    }
  };
  return (
    <div className="flex 2xl:gap-12 2xl:px-12 gap-6 mt-3  max-lg:flex-col bg-white px-6 dark:bg-dark2 pb-6">
      <div className="lg:w-[306px] lg:shrink-0">
        <div className="lg:space-y-4 lg:pb-8 max-lg:grid sm:grid-cols-2 max-lg:gap-6 uk-sticky uk-active uk-sticky-fixed">
          <div className="border border-[#DEE0E6] dark:border-slate-700 rounded-xl lg:-translate-y-[150px]">
            {_get(profile, 'description') && (
              <div className=" border-b p-3 text-sm truncate">
                {_get(profile, 'description', '')}
              </div>
            )}
            <h3 className="font-semibold text-[22px] p-3 "> Giới thiệu </h3>
            <ul className="text-gray-700  p-3 text-sm dark:text-white/80">
              <li className="flex border-b border-b-[#E5E7EB] dark:border-b-slate-700 px-3 py-2 gap-1 items-center">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.7467 5.63317C13.0467 2.55317 10.3601 1.1665 8.00006 1.1665C8.00006 1.1665 8.00006 1.1665 7.9934 1.1665C5.64006 1.1665 2.94673 2.5465 2.24673 5.6265C1.46673 9.0665 3.5734 11.9798 5.48006 13.8132C6.18673 14.4932 7.0934 14.8332 8.00006 14.8332C8.90673 14.8332 9.8134 14.4932 10.5134 13.8132C12.4201 11.9798 14.5267 9.07317 13.7467 5.63317ZM8.00006 8.97317C6.84006 8.97317 5.90006 8.03317 5.90006 6.87317C5.90006 5.71317 6.84006 4.77317 8.00006 4.77317C9.16006 4.77317 10.1001 5.71317 10.1001 6.87317C10.1001 8.03317 9.16006 8.97317 8.00006 8.97317Z"
                    fill="#657384"
                  />
                </svg>
                <div className="flex">
                  {city ? (
                    <>
                      Đến từ&nbsp;
                      <p className="font-semibold text-black dark:text-white">{city}</p>
                    </>
                  ) : (
                    <p className="font-normal">Chưa cập nhật nơi sống</p>
                  )}
                </div>
              </li>
              {profile.schools && profile.schools.length > 0 ? (
                profile.schools.map((item, index) => (
                  <li
                    key={`${item.workPlaceName}-${index}`}
                    className="flex border-b border-b-[#E5E7EB] dark:border-b-slate-700 px-3 py-2 gap-1"
                  >
                    <div className="pt-[2px]">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.6673 10.6667V12.3333C13.6673 13.62 12.6207 14.6667 11.334 14.6667H4.66732C3.38065 14.6667 2.33398 13.62 2.33398 12.3333V11.9C2.33398 10.8533 3.18732 10 4.23398 10H13.0007C13.3673 10 13.6673 10.3 13.6673 10.6667Z"
                          fill="#657384"
                        />
                        <path
                          d="M10.334 1.3335H5.66732C3.00065 1.3335 2.33398 2.00016 2.33398 4.66683V9.72016C2.84065 9.2735 3.50732 9.00016 4.23398 9.00016H13.0007C13.3673 9.00016 13.6673 8.70016 13.6673 8.3335V4.66683C13.6673 2.00016 13.0007 1.3335 10.334 1.3335ZM8.66732 7.16683H5.33398C5.06065 7.16683 4.83398 6.94016 4.83398 6.66683C4.83398 6.3935 5.06065 6.16683 5.33398 6.16683H8.66732C8.94065 6.16683 9.16732 6.3935 9.16732 6.66683C9.16732 6.94016 8.94065 7.16683 8.66732 7.16683ZM10.6673 4.8335H5.33398C5.06065 4.8335 4.83398 4.60683 4.83398 4.3335C4.83398 4.06016 5.06065 3.8335 5.33398 3.8335H10.6673C10.9407 3.8335 11.1673 4.06016 11.1673 4.3335C11.1673 4.60683 10.9407 4.8335 10.6673 4.8335Z"
                          fill="#657384"
                        />
                      </svg>
                    </div>
                    <div className="flex gap-[10px] flex-col">
                      <div className="flex items-center">
                        Học tại&nbsp;
                        <span className="font-bold truncate ">
                          {item.workPlaceName}
                        </span>
                      </div>
                      <span className="text-xs text-[#657384]">
                        [{renderDate(item.from)}-{renderDate(item.to)}]
                      </span>
                    </div>
                  </li>
                ))
              ) : (
                <li className="flex border-b border-b-[#E5E7EB] dark:border-b-slate-700 px-3 py-2 gap-1 items-center">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.6673 10.6667V12.3333C13.6673 13.62 12.6207 14.6667 11.334 14.6667H4.66732C3.38065 14.6667 2.33398 13.62 2.33398 12.3333V11.9C2.33398 10.8533 3.18732 10 4.23398 10H13.0007C13.3673 10 13.6673 10.3 13.6673 10.6667Z"
                      fill="#657384"
                    />
                    <path
                      d="M10.334 1.3335H5.66732C3.00065 1.3335 2.33398 2.00016 2.33398 4.66683V9.72016C2.84065 9.2735 3.50732 9.00016 4.23398 9.00016H13.0007C13.3673 9.00016 13.6673 8.70016 13.6673 8.3335V4.66683C13.6673 2.00016 13.0007 1.3335 10.334 1.3335ZM8.66732 7.16683H5.33398C5.06065 7.16683 4.83398 6.94016 4.83398 6.66683C4.83398 6.3935 5.06065 6.16683 5.33398 6.16683H8.66732C8.94065 6.16683 9.16732 6.3935 9.16732 6.66683C9.16732 6.94016 8.94065 7.16683 8.66732 7.16683ZM10.6673 4.8335H5.33398C5.06065 4.8335 4.83398 4.60683 4.83398 4.3335C4.83398 4.06016 5.06065 3.8335 5.33398 3.8335H10.6673C10.9407 3.8335 11.1673 4.06016 11.1673 4.3335C11.1673 4.60683 10.9407 4.8335 10.6673 4.8335Z"
                      fill="#657384"
                    />
                  </svg>
                  <div className="flex items-center">Chưa cập nhật nơi học</div>
                </li>
              )}

              {profile.companies && profile.companies.length > 0 ? (
                profile.companies.map((item, index) => (
                  <li
                    key={`${item.workPlaceName}-${index}`}
                    className="flex border-b border-b-[#E5E7EB] dark:border-b-slate-700 px-3 py-2 gap-1"
                  >
                    <div className="pt-[2px]">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.6673 10.6667V12.3333C13.6673 13.62 12.6207 14.6667 11.334 14.6667H4.66732C3.38065 14.6667 2.33398 13.62 2.33398 12.3333V11.9C2.33398 10.8533 3.18732 10 4.23398 10H13.0007C13.3673 10 13.6673 10.3 13.6673 10.6667Z"
                          fill="#657384"
                        />
                        <path
                          d="M10.334 1.3335H5.66732C3.00065 1.3335 2.33398 2.00016 2.33398 4.66683V9.72016C2.84065 9.2735 3.50732 9.00016 4.23398 9.00016H13.0007C13.3673 9.00016 13.6673 8.70016 13.6673 8.3335V4.66683C13.6673 2.00016 13.0007 1.3335 10.334 1.3335ZM8.66732 7.16683H5.33398C5.06065 7.16683 4.83398 6.94016 4.83398 6.66683C4.83398 6.3935 5.06065 6.16683 5.33398 6.16683H8.66732C8.94065 6.16683 9.16732 6.3935 9.16732 6.66683C9.16732 6.94016 8.94065 7.16683 8.66732 7.16683ZM10.6673 4.8335H5.33398C5.06065 4.8335 4.83398 4.60683 4.83398 4.3335C4.83398 4.06016 5.06065 3.8335 5.33398 3.8335H10.6673C10.9407 3.8335 11.1673 4.06016 11.1673 4.3335C11.1673 4.60683 10.9407 4.8335 10.6673 4.8335Z"
                          fill="#657384"
                        />
                      </svg>
                    </div>

                    <div className="flex gap-[10px] flex-col">
                      <div className="flex items-center">
                        Làm việc tại&nbsp;
                        <span className="font-bold truncate">
                          {item.workPlaceName}
                        </span>
                      </div>
                      <span className="text-xs text-[#657384]">
                        [{renderDate(item.from)}-{renderDate(item.to)}]
                      </span>
                    </div>
                  </li>
                ))
              ) : (
                <li className="flex border-b border-b-[#E5E7EB] dark:border-b-slate-700 px-3 py-2 gap-1 items-center">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.6673 10.6667V12.3333C13.6673 13.62 12.6207 14.6667 11.334 14.6667H4.66732C3.38065 14.6667 2.33398 13.62 2.33398 12.3333V11.9C2.33398 10.8533 3.18732 10 4.23398 10H13.0007C13.3673 10 13.6673 10.3 13.6673 10.6667Z"
                      fill="#657384"
                    />
                    <path
                      d="M10.334 1.3335H5.66732C3.00065 1.3335 2.33398 2.00016 2.33398 4.66683V9.72016C2.84065 9.2735 3.50732 9.00016 4.23398 9.00016H13.0007C13.3673 9.00016 13.6673 8.70016 13.6673 8.3335V4.66683C13.6673 2.00016 13.0007 1.3335 10.334 1.3335ZM8.66732 7.16683H5.33398C5.06065 7.16683 4.83398 6.94016 4.83398 6.66683C4.83398 6.3935 5.06065 6.16683 5.33398 6.16683H8.66732C8.94065 6.16683 9.16732 6.3935 9.16732 6.66683C9.16732 6.94016 8.94065 7.16683 8.66732 7.16683ZM10.6673 4.8335H5.33398C5.06065 4.8335 4.83398 4.60683 4.83398 4.3335C4.83398 4.06016 5.06065 3.8335 5.33398 3.8335H10.6673C10.9407 3.8335 11.1673 4.06016 11.1673 4.3335C11.1673 4.60683 10.9407 4.8335 10.6673 4.8335Z"
                      fill="#657384"
                    />
                  </svg>
                  <div className="flex items-center">
                    Chưa cập nhật nơi làm việc
                  </div>
                </li>
              )}
              <li className="flex border-b border-b-[#E5E7EB] dark:border-b-slate-700 px-3 py-2 gap-1 items-center">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.6467 1.55317C14.1667 1.0065 13.4533 0.666504 12.6667 0.666504C11.92 0.666504 11.24 0.973171 10.7533 1.47317C10.4733 1.75984 10.26 2.1065 10.1333 2.49317C10.0467 2.75984 10 3.03984 10 3.33317C10 3.83317 10.14 4.3065 10.3867 4.7065C10.52 4.93317 10.6933 5.13984 10.8933 5.31317C11.36 5.73984 11.98 5.99984 12.6667 5.99984C12.96 5.99984 13.24 5.95317 13.5 5.85984C14.1133 5.6665 14.6267 5.2465 14.9467 4.7065C15.0867 4.47984 15.1933 4.21984 15.2533 3.95317C15.3067 3.75317 15.3333 3.5465 15.3333 3.33317C15.3333 2.65317 15.0733 2.0265 14.6467 1.55317ZM13.66 3.81984H13.1667V4.33984C13.1667 4.61317 12.94 4.83984 12.6667 4.83984C12.3933 4.83984 12.1667 4.61317 12.1667 4.33984V3.81984H11.6733C11.4 3.81984 11.1733 3.59317 11.1733 3.31984C11.1733 3.0465 11.4 2.81984 11.6733 2.81984H12.1667V2.3465C12.1667 2.07317 12.3933 1.8465 12.6667 1.8465C12.94 1.8465 13.1667 2.07317 13.1667 2.3465V2.81984H13.66C13.9333 2.81984 14.16 3.0465 14.16 3.31984C14.16 3.59317 13.94 3.81984 13.66 3.81984Z"
                    fill="#657384"
                  />
                  <path
                    d="M14.6673 8.00016C14.6673 7.12683 14.5007 6.28683 14.1873 5.52016C13.9807 5.66683 13.7473 5.78016 13.5007 5.86016C13.4273 5.88683 13.354 5.90683 13.274 5.92683C13.5273 6.56683 13.6673 7.26683 13.6673 8.00016C13.6673 9.54683 13.0407 10.9535 12.0273 11.9802C11.834 11.7335 11.5873 11.5068 11.294 11.3135C9.48732 10.1002 6.52732 10.1002 4.70732 11.3135C4.41398 11.5068 4.17398 11.7335 3.97398 11.9802C2.96065 10.9535 2.33398 9.54683 2.33398 8.00016C2.33398 4.8735 4.87398 2.3335 8.00065 2.3335C8.72732 2.3335 9.42732 2.4735 10.0673 2.72683C10.0873 2.64683 10.1073 2.5735 10.134 2.4935C10.214 2.24683 10.3273 2.02016 10.4807 1.8135C9.71398 1.50016 8.87398 1.3335 8.00065 1.3335C4.32732 1.3335 1.33398 4.32683 1.33398 8.00016C1.33398 9.9335 2.16732 11.6735 3.48732 12.8935C3.48732 12.9002 3.48732 12.9002 3.48065 12.9068C3.54732 12.9735 3.62732 13.0268 3.69398 13.0868C3.73398 13.1202 3.76732 13.1535 3.80732 13.1802C3.92732 13.2802 4.06065 13.3735 4.18732 13.4668C4.23398 13.5002 4.27398 13.5268 4.32065 13.5602C4.44732 13.6468 4.58065 13.7268 4.72065 13.8002C4.76732 13.8268 4.82065 13.8602 4.86732 13.8868C5.00065 13.9602 5.14065 14.0268 5.28732 14.0868C5.34065 14.1135 5.39398 14.1402 5.44732 14.1602C5.59398 14.2202 5.74065 14.2735 5.88732 14.3202C5.94065 14.3402 5.99398 14.3602 6.04732 14.3735C6.20732 14.4202 6.36732 14.4602 6.52732 14.5002C6.57398 14.5135 6.62065 14.5268 6.67398 14.5335C6.86065 14.5735 7.04732 14.6002 7.24065 14.6202C7.26732 14.6202 7.29398 14.6268 7.32065 14.6335C7.54732 14.6535 7.77398 14.6668 8.00065 14.6668C8.22732 14.6668 8.45398 14.6535 8.67398 14.6335C8.70065 14.6335 8.72732 14.6268 8.75398 14.6202C8.94732 14.6002 9.13398 14.5735 9.32065 14.5335C9.36732 14.5268 9.41398 14.5068 9.46732 14.5002C9.62732 14.4602 9.79398 14.4268 9.94732 14.3735C10.0007 14.3535 10.054 14.3335 10.1073 14.3202C10.254 14.2668 10.4073 14.2202 10.5473 14.1602C10.6007 14.1402 10.654 14.1135 10.7073 14.0868C10.8473 14.0268 10.9873 13.9602 11.1273 13.8868C11.1807 13.8602 11.2273 13.8268 11.274 13.8002C11.4073 13.7202 11.5407 13.6468 11.674 13.5602C11.7207 13.5335 11.7607 13.5002 11.8073 13.4668C11.9407 13.3735 12.0673 13.2802 12.1873 13.1802C12.2273 13.1468 12.2607 13.1135 12.3007 13.0868C12.374 13.0268 12.4473 12.9668 12.514 12.9068C12.514 12.9002 12.514 12.9002 12.5073 12.8935C13.834 11.6735 14.6673 9.9335 14.6673 8.00016Z"
                    fill="#657384"
                  />
                  <path
                    d="M8 4.62012C6.62 4.62012 5.5 5.74012 5.5 7.12012C5.5 8.47345 6.56 9.57345 7.96667 9.61345C7.98667 9.61345 8.01333 9.61345 8.02667 9.61345C8.04 9.61345 8.06 9.61345 8.07333 9.61345C8.08 9.61345 8.08667 9.61345 8.08667 9.61345C9.43333 9.56678 10.4933 8.47345 10.5 7.12012C10.5 5.74012 9.38 4.62012 8 4.62012Z"
                    fill="#657384"
                  />
                </svg>

                <div className="flex items-center">
                  Giới tính&nbsp;
                  <RenderGender gender={sex} />
                </div>
              </li>
              <li className="flex border-b border-b-[#E5E7EB] dark:border-b-slate-700 px-3 py-2 gap-1 items-center">
                <svg
                  width="14"
                  height="12"
                  viewBox="0 0 14 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.96065 0.0668945C8.75399 0.0668945 7.67398 0.653561 7.00065 1.55356C6.32732 0.653561 5.24732 0.0668945 4.04065 0.0668945C1.99398 0.0668945 0.333984 1.73356 0.333984 3.79356C0.333984 4.58689 0.460651 5.32023 0.680651 6.00023C1.73398 9.33356 4.98065 11.3269 6.58732 11.8736C6.81398 11.9536 7.18732 11.9536 7.41398 11.8736C9.02065 11.3269 12.2673 9.33356 13.3207 6.00023C13.5407 5.32023 13.6673 4.58689 13.6673 3.79356C13.6673 1.73356 12.0073 0.0668945 9.96065 0.0668945Z"
                    fill="#657384"
                  />
                </svg>
                <div className="flex items-center">
                  Mối quan hệ&nbsp;
                  <span className="font-semibold text-black dark:text-white">
                    {_.get(profile, 'marry', 0) === 1
                      ? ' Kết Hôn'
                      : ' Độc thân'}
                  </span>
                </div>
              </li>
              {/* <li className="flex items-center gap-3 border-b border-b-[#E5E7EB] dark:border-b-slate-700 px-3 py-2">
            <div>
              Flowwed By <span className="font-semibold text-black dark:text-white"> 3,240 People </span>
            </div>
          </li> */}
            </ul>
            <ArenaTrophiesCard userId={profile?.userId} />
            <div className="px-3 flex flex-col gap-[10px] pb-3">
              <EditProfiledDialog
                profile={profile}
                onUpdateSuccess={handleUpdateProfileSuccess}
              />

              <div
                onClick={() => {
                  navigate('/account/cabplus');
                }}
                className="text-base font-medium border border-[#DEE8FF] dark:border-slate-700 bg-white dark:bg-slate-800 backdrop-blur-sm   text-[#0057FF] dark:text-blue-300 cursor-pointer rounded-xl gap-[10px] py-2 flex items-center justify-center "
              >
                <svg
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.8895 5.20979L17.2995 8.02979C17.4895 8.41979 17.9995 8.78979 18.4295 8.86979L20.9795 9.28979C22.6095 9.55979 22.9895 10.7398 21.8195 11.9198L19.8295 13.9098C19.4995 14.2398 19.3095 14.8898 19.4195 15.3598L19.9895 17.8198C20.4395 19.7598 19.3995 20.5198 17.6895 19.4998L15.2995 18.0798C14.8695 17.8198 14.1495 17.8198 13.7195 18.0798L11.3295 19.4998C9.61945 20.5098 8.57945 19.7598 9.02945 17.8198L9.59945 15.3598C9.68945 14.8798 9.49945 14.2298 9.16945 13.8998L7.17945 11.9098C6.00945 10.7398 6.38945 9.55979 8.01945 9.27979L10.5695 8.85979C10.9995 8.78979 11.5095 8.40979 11.6995 8.01979L13.1095 5.19979C13.8795 3.67979 15.1195 3.67979 15.8895 5.20979Z"
                    fill="#0057FF"
                  />
                  <path
                    d="M8.5 5.75H2.5C2.09 5.75 1.75 5.41 1.75 5C1.75 4.59 2.09 4.25 2.5 4.25H8.5C8.91 4.25 9.25 4.59 9.25 5C9.25 5.41 8.91 5.75 8.5 5.75Z"
                    fill="#0057FF"
                  />
                  <path
                    d="M5.5 19.75H2.5C2.09 19.75 1.75 19.41 1.75 19C1.75 18.59 2.09 18.25 2.5 18.25H5.5C5.91 18.25 6.25 18.59 6.25 19C6.25 19.41 5.91 19.75 5.5 19.75Z"
                    fill="#0057FF"
                  />
                  <path
                    d="M3.5 12.75H2.5C2.09 12.75 1.75 12.41 1.75 12C1.75 11.59 2.09 11.25 2.5 11.25H3.5C3.91 11.25 4.25 11.59 4.25 12C4.25 12.41 3.91 12.75 3.5 12.75Z"
                    fill="#0057FF"
                  />
                </svg>

                <span>Nâng cấp CAB+</span>
                <svg
                  width="29"
                  height="20"
                  viewBox="0 0 29 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="28"
                    height="19"
                    rx="2"
                    fill="url(#paint0_linear_72_97798)"
                  />
                  <path
                    d="M5.45881 14.5V5.77273H8.5696C9.24858 5.77273 9.81108 5.89631 10.2571 6.14347C10.7031 6.39062 11.0369 6.72869 11.2585 7.15767C11.4801 7.58381 11.5909 8.06392 11.5909 8.59801C11.5909 9.13494 11.4787 9.6179 11.2543 10.0469C11.0327 10.473 10.6974 10.8111 10.2486 11.0611C9.80256 11.3082 9.24148 11.4318 8.56534 11.4318H6.42614V10.3153H8.44602C8.875 10.3153 9.22301 10.2415 9.49006 10.0938C9.7571 9.94318 9.95312 9.73864 10.0781 9.48011C10.2031 9.22159 10.2656 8.92756 10.2656 8.59801C10.2656 8.26847 10.2031 7.97585 10.0781 7.72017C9.95312 7.46449 9.75568 7.2642 9.4858 7.11932C9.21875 6.97443 8.86648 6.90199 8.42898 6.90199H6.77557V14.5H5.45881ZM13.0923 14.5V7.95455H14.3238V8.99432H14.392C14.5113 8.64205 14.7216 8.36506 15.0227 8.16335C15.3267 7.95881 15.6704 7.85653 16.054 7.85653C16.1335 7.85653 16.2273 7.85937 16.3352 7.86506C16.446 7.87074 16.5327 7.87784 16.5952 7.88636V9.10511C16.544 9.09091 16.4531 9.07528 16.3224 9.05824C16.1917 9.03835 16.0611 9.02841 15.9304 9.02841C15.6292 9.02841 15.3608 9.09233 15.125 9.22017C14.892 9.34517 14.7074 9.51989 14.571 9.74432C14.4346 9.96591 14.3665 10.2187 14.3665 10.5028V14.5H13.0923ZM20.2805 14.6321C19.6669 14.6321 19.1314 14.4915 18.674 14.2102C18.2166 13.929 17.8615 13.5355 17.6086 13.0298C17.3558 12.5241 17.2294 11.9332 17.2294 11.2571C17.2294 10.5781 17.3558 9.98437 17.6086 9.47585C17.8615 8.96733 18.2166 8.57244 18.674 8.29119C19.1314 8.00994 19.6669 7.86932 20.2805 7.86932C20.8941 7.86932 21.4297 8.00994 21.887 8.29119C22.3444 8.57244 22.6995 8.96733 22.9524 9.47585C23.2052 9.98437 23.3316 10.5781 23.3316 11.2571C23.3316 11.9332 23.2052 12.5241 22.9524 13.0298C22.6995 13.5355 22.3444 13.929 21.887 14.2102C21.4297 14.4915 20.8941 14.6321 20.2805 14.6321ZM20.2848 13.5625C20.6825 13.5625 21.012 13.4574 21.2734 13.2472C21.5348 13.0369 21.728 12.7571 21.853 12.4077C21.9808 12.0582 22.0447 11.6733 22.0447 11.2528C22.0447 10.8352 21.9808 10.4517 21.853 10.1023C21.728 9.75 21.5348 9.46733 21.2734 9.25426C21.012 9.04119 20.6825 8.93466 20.2848 8.93466C19.8842 8.93466 19.5518 9.04119 19.2876 9.25426C19.0262 9.46733 18.8316 9.75 18.7038 10.1023C18.5788 10.4517 18.5163 10.8352 18.5163 11.2528C18.5163 11.6733 18.5788 12.0582 18.7038 12.4077C18.8316 12.7571 19.0262 13.0369 19.2876 13.2472C19.5518 13.4574 19.8842 13.5625 20.2848 13.5625Z"
                    fill="white"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_72_97798"
                      x1="28.5"
                      y1="0.5"
                      x2="4.00134"
                      y2="23.2676"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#027BFE" />
                      <stop offset="1" stopColor="#596FD2" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
            </div>
          </div>
          <div className="w-full lg:-translate-y-[120px]">
            {/* Loại bảng xếp hạng */}
            <div className="mb-3 grid grid-cols-2 gap-1 rounded-xl border border-[#DEE0E6] bg-slate-100 p-1 dark:border-slate-700 dark:bg-slate-900">
              {[
                { key: 'donator', label: 'Top Donate' },
                { key: 'react', label: 'Top tương tác' },
              ].map((t) => (
                <button
                  key={t.key}
                  type="button"
                  onClick={() => setActiveTabLeaderboard(t.key)}
                  className={`h-9 rounded-lg text-sm font-semibold transition ${
                    activeTabLeaderboard === t.key
                      ? 'bg-white text-[#0057FF] shadow-sm dark:bg-slate-700 dark:text-white'
                      : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-white'
                  }`}
                >
                  {t.label}
                </button>
              ))}
            </div>

            <div className="relative flex flex-col gap-4 rounded-[20px] border border-[#DEE0E6] bg-white p-4 dark:border-slate-700 dark:bg-dark2">
              {/* Phạm vi thời gian */}
              <div className="grid grid-cols-2 gap-1 rounded-lg bg-slate-100 p-1 dark:bg-slate-900">
                <button
                  type="button"
                  onClick={() => setIsCurrent(true)}
                  className={`h-8 rounded-md text-[13px] font-medium transition ${
                    isCurrent
                      ? 'bg-[#0057FF] text-white shadow-sm'
                      : 'text-slate-500 dark:text-slate-400'
                  }`}
                >
                  Top hiện tại
                </button>
                <button
                  type="button"
                  onClick={() => setIsCurrent(false)}
                  className={`h-8 rounded-md text-[13px] font-medium transition ${
                    !isCurrent
                      ? 'bg-[#0057FF] text-white shadow-sm'
                      : 'text-slate-500 dark:text-slate-400'
                  }`}
                >
                  Top theo tháng
                </button>
              </div>

              {!isCurrent && (
                <CustomDropdown
                  value={month.toString()}
                  options={Array.from({ length: 12 }, (_, i) => ({
                    label: `Tháng ${i + 1}`,
                    value: `${i + 1}`,
                  }))}
                  placeholder="Tháng"
                  customClassName="py-2 h-10 px-3 text-base font-semibold"
                  onChange={(val) => setMonth(Number(val))}
                />
              )}
              {activeTabLeaderboard === 'react' && (
                <UkSlider sliderItems={leaderboard?.topAction} />
              )}
              {activeTabLeaderboard === 'donator' && (
                <UkSlider sliderItems={leaderboard?.topMoney} />
              )}

              <div className="absolute bottom-0 right-[20px] translate-y-[30px]">
                {/* <TrapeziumButton onClick={() => setIsOpenFullTop(true)}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.1667 5.83301L5 14.9997"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                    <path
                      d="M9.16602 5.1096C9.16602 5.1096 13.8606 4.71385 14.5731 5.42628C15.2855 6.1387 14.8897 10.8333 14.8897 10.8333"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span className="skew-x-[20deg]">Xem thêm</span>
                </TrapeziumButton> */}
                {isOpenFullTop && (
                  <DialogTop
                    handleClose={() => setIsOpenFullTop(false)}
                    open={isOpenFullTop}
                    monthCurrent={month}
                    current={isCurrent}
                    activeTabCurrent={activeTabLeaderboard}
                  />
                )}
              </div>
            </div>

            {/* SVG Filter */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              className="hidden"
            >
              <defs>
                <filter id="fancy-goooooo">
                  <feGaussianBlur
                    in="SourceGraphic"
                    stdDeviation="9"
                    result="blur"
                  />
                  <feColorMatrix
                    in="blur"
                    mode="matrix"
                    values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
                    result="goo"
                  />
                  <feComposite in="SourceGraphic" in2="goo" operator="atop" />
                </filter>
              </defs>
            </svg>
          </div>
        </div>
      </div>
      <div className="flex-1 xl:space-y-6 space-y-3">
        {!userId && <MissingUsernameBanner username={(profile as any)?.username} />}
        {/* Trang của chính mình: nhắc các kiểu donate chưa bật (người xem không thấy). */}
        {!userId && profile?.canReceiveDonation && profile?.userId && (
          <DonateSetupNudge userId={profile.userId} />
        )}
        <nav className="flex gap-0.5 border-b border-[#C8CCD8] -mb-px text-gray-600 font-medium text-[15px]  dark:text-white max-md:w-full max-md:overflow-x-auto">
          {!userId && (
            <div
              className={`cursor-pointer inline-block shrink-0 whitespace-nowrap py-3 leading-8 px-4 font-semibold text-base border-b-2   ${
                tabActive === 'dashboard'
                  ? 'border-[#234093] text-[#234093]'
                  : 'border-transparent'
              } `}
              onClick={() => changeTab && changeTab('dashboard')}
            >
              Tổng quan
            </div>
          )}
          <div
            className={`cursor-pointer inline-block shrink-0 whitespace-nowrap py-3 leading-8 px-4 font-semibold text-base border-b-2   ${
              tabActive === 'timeline'
                ? 'border-[#234093] text-[#234093]'
                : 'border-transparent'
            } `}
            onClick={() => changeTab && changeTab('timeline')}
          >
            Bài viết
          </div>
          <div
            className={`cursor-pointer inline-block shrink-0 whitespace-nowrap py-3 leading-8 px-4 font-semibold text-base border-b-2   ${
              tabActive === 'friend'
                ? 'border-[#234093] text-[#234093]'
                : 'border-transparent'
            } `}
            onClick={() => {
              changeTab && changeTab('friend');
              // navigate(userId ? `/friend/${userId}` : `/friend/${_get(profile, 'username', '')}`);
            }}
          >
            Bạn bè
            {/* <span className="text-xs pl-2 font-normal lg:inline-block hidden">
              {_get(profile, 'totalFriend', '')}
            </span> */}
          </div>

          <div
            className={`cursor-pointer inline-block shrink-0 whitespace-nowrap py-3 leading-8 px-4 font-semibold text-base border-b-2   ${
              tabActive === 'group'
                ? 'border-[#234093] text-[#234093]'
                : 'border-transparent'
            } `}
            onClick={() => changeTab && changeTab('group')}
          >
            Cộng đồng
          </div>
          <div
            className={`cursor-pointer inline-block shrink-0 whitespace-nowrap py-3 leading-8 px-4 font-semibold text-base border-b-2 ${
              tabActive === 'quyen-gop'
                ? 'border-[#234093] text-[#234093]'
                : 'border-transparent'
            } `}
            onClick={() => changeTab && changeTab('quyen-gop')}
          >
            Quyên góp
          </div>
          {collab?.visible && (
            <div
              className={`cursor-pointer inline-block shrink-0 whitespace-nowrap py-3 leading-8 px-4 font-semibold text-base border-b-2 ${
                tabActive === BRAND_COLLAB_TAB
                  ? 'border-[#234093] text-[#234093]'
                  : 'border-transparent'
              } `}
              onClick={() => changeTab && changeTab(BRAND_COLLAB_TAB)}
            >
              {BRAND_PROFILE_COPY.tabLabel}
            </div>
          )}
          <div
            className={`cursor-pointer inline-block shrink-0 whitespace-nowrap py-3 leading-8 px-4 font-semibold text-base border-b-2 ${
              tabActive === 'history-donate'
                ? 'border-[#234093] text-[#234093]'
                : 'border-transparent'
            } `}
            onClick={() => changeTab && changeTab('history-donate')}
          >
            Doanh thu
          </div>
          <div
            className={`cursor-pointer inline-block shrink-0 whitespace-nowrap py-3 leading-8 px-4 font-semibold text-base border-b-2 ${
              tabActive === 'settings'
                ? 'border-[#234093] text-[#234093]'
                : 'border-transparent'
            } `}
            onClick={() => changeTab && changeTab('settings')}
          >
            Cài đặt
          </div>
        </nav>
        <div>{renderContent(tabActive)}</div>
      </div>
      {tabActive !== 'settings' &&
        tabActive !== 'history-donate' &&
        tabActive !== 'quyen-gop' &&
        tabActive !== 'dashboard' && (
        <div className="mt-[55px] h-fit sticky top-[84px] max-2xl:hidden">
          <Advertisement />
        </div>
      )}
    </div>
  );
};

export const renderDate = (date: string) => {
  if (!date || !dayjs(date).isValid()) return 'Chưa có';
  return dayjs(date).format('YYYY');
};
const RenderOther = ({ list }: { list: any[] }) => {
  if (_.isEmpty(list)) return <div className="text-slate-500">Trống</div>;
  return (
    <div className="flex flex-col gap-2">
      {_.map(list, (item, index) => (
        <div key={index} className="flex items-center gap-1">
          <span className="font-bold">{item.workPlaceName}</span>
          <span className="text-xs text-slate-500">
            ({renderDate(item.from)} - {renderDate(item.to)})
          </span>
        </div>
      ))}
    </div>
  );
};

export const RenderGender = ({ gender }: { gender: string }) => {
  const text = gender === 'male' ? 'Nam' : gender === 'female' ? 'Nữ' : 'Khác';
  return (
    <span className="font-semibold text-black dark:text-white"> {text} </span>
  );
};

const RenderFavourite = ({ list }: { list: any[] }) => {
  if (_.isEmpty(list)) return null;
  return (
    <div className="flex flex-wrap gap-1 text-sm mt-4 font-semibold capitalize">
      {_.map(list, (item, index) => (
        <div
          key={item.categoryId}
          className="inline-flex items-center gap-2 py-0.5 px-2.5 border shadow rounded-full border-gray-100"
        >
          {item.categoryName}
        </div>
      ))}
    </div>
  );
};

Timeline.propTypes = {};
export default Timeline;
